export const SEND = "Отправить";



// WEBPACK FOOTER //
// ./src/utilities/const.js